<template>
  <div class="index">
    <div class="common_mbx">
      您当前的位置：<router-link to='/index' tag='span'>首页</router-link> ><router-link to='/our' tag='span'> 我们</router-link> > 新闻
    </div>
    <div class="common_wrap">
      <img src="../../static/images/news.jpg" class="top_banner">
      <div class="news_lists clearfix">
        <div class="news_item clearfix" v-for='item in news'>
          <router-link :to='"/our/news/detail/"+item.id'>
            <img :src="domain+item.litpic">
            <div class="news_text">
              <div class="text_top">
                <p class="news_name">{{item.title}}</p>
                <p class="news_time">{{item.updatetime | time}}</p>
              </div>
              <div class="news_desc">{{item.description}}</div>
            </div>
          </router-link>
        </div>

      </div>
        <div class="more" @click='more' v-show='showmore'>
          加载更多
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      news:[],
      limit:10,
      showmore:true
    }
  },
  watch:{
    '$route':function(to,from){
      this.getList()
    }
  },
  mounted:function(){
    this.domain=this._routerRoot.domain
    this.getList()
  },
  methods:{
    getList:function(type){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_lists', this.$qs.stringify({
        cid:18,
        page:1,
        limit:this.limit
      }))
      .then(response => {
        console.log(response);
        this.news=response.data.data
        if(this.news.length<this.limit&&type==1){
          this.showmore=false;
          alertMessage('列表已全部加载完')
        }
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      })
      .catch(error => {
        console.log(error);
      });
    },
    more(){
      this.limit+=10;
      this.getList(1)
    }
  }

}
</script>

<style scoped>

 .common_wrap{
  width: 1200px;
  margin: 0 auto;
 }
 .top_banner{
  margin-bottom: 72px;
 }
 .news_item{
  width: 50%;
  height: 170px;
  float: left;
  margin-bottom: 57px;
  overflow: hidden;
 }
 .news_item img{
  width: 235px;
  float: left;
 }
 .news_text{
  width: 324px;
  float: right;
  margin-right: 14px;
 }
 .text_top{
  border-bottom: 1px solid #d1d1d1;
  padding-bottom: 14px;
  margin-bottom: 14px;
 }
 .news_name{
  font-size: 18px;
  color: #000;
  margin-bottom: 20px;
 }
 .news_time{
  color: #b2b2b2;
  font-size: 14px;
 }
 .news_desc{
  font-size: 14px;
  color: #000000;
  line-height: 150%;
 }
 .more{
  width: 120px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  border-radius: 4px;
  background-color: #3478f7;
  color: #fff;
  margin: 0 auto;
  margin-bottom: 40px;
  font-size: 14px;
  cursor: pointer;
 }
</style>


// WEBPACK FOOTER //
// src/components/news.vue